import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from "react-helmet";
import Header from '../body_root/header';
import Footers from '../body_root/footer';
import Navbar from '../body_root/Navbar';
import './orders_management.css';
import { Toast } from '../components_root/ToastContext';
import { VscDashboard } from "react-icons/vsc";
import { MdAnalytics, MdDashboard, MdHome, MdLocationCity, MdMenu, MdMonitor, MdOutlineAnalytics, MdSettings, MdSettingsAccessibility, MdTraffic } from "react-icons/md";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};


export default function Orders_management() {
    const [text, setText] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(true);
    const [collapsed, setCollapsed] = useState(false); 
    const [activeTab, setActiveTab] = useState("home");
  
    return (
        <div> 
orders_management
            
        </div>
    );
}
